import {
  SEARCH_BOX_SHOW_ALL_RESULTS_BUTTON_CLICK,
  SEARCH_BOX_SUGGESTED_PRODUCT_CLICK,
  SEARCH_BUTTON_CHANGE,
} from 'shared/experiments/consts'
import { getExperimentOnClient } from 'shared/experiments/utils/experiments'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import store from 'shared/store'
import { isMobile } from 'shared/utils/deviceClassUtils'
import { SELECTOR_CONTAINER } from 'views/containers/browser/SearchBoxContainer/consts'

export default () => {
  const { deviceClass } =
    store.getState()?.publicRuntimeConfig.publicConfig || {}
  const isMobileDevice = isMobile(deviceClass)
  const { isEnabled } = getExperimentOnClient(SEARCH_BUTTON_CHANGE)

  if (!isEnabled || !isMobileDevice) return

  const trackEvents = (event: Event) => {
    const target = <HTMLElement>event.target

    if (target.closest('[data-clientside-hook~="SearchBoxListItemLink"]')) {
      trackOptimizelyEvent(SEARCH_BOX_SUGGESTED_PRODUCT_CLICK)
    }
    if (
      target.closest(
        '[data-qa-id~="search-results-show-all-results-button"]'
      ) ||
      target.closest('[data-qa-id~="form-show-all-results-button"]')
    ) {
      trackOptimizelyEvent(SEARCH_BOX_SHOW_ALL_RESULTS_BUTTON_CLICK)
    }
  }
  const queryWrapper = document.querySelector(SELECTOR_CONTAINER)
  queryWrapper?.addEventListener('click', trackEvents)
}
